import React, { useState } from 'react';
import { X, User, Lock, Shield } from 'lucide-react';
import userManagementService from '../../../services/userManagementService';

const AddUserModal = ({ onClose, onUserAdded }) => {
  const [formData, setFormData] = useState({
    username: '',
    fullName: '',
    role: 'order_user',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setLoading(true);
    setError('');

    // Basic validation
    if (!formData?.username || !formData?.fullName || !formData?.password) {
      setError('Tutti i campi sono obbligatori');
      setLoading(false);
      return;
    }

    if (formData?.password?.length < 6) {
      setError('La password deve contenere almeno 6 caratteri');
      setLoading(false);
      return;
    }

    try {
      const result = await userManagementService.createUser(formData);
      if (!result?.success) {
        setError(result?.error || 'Errore nella creazione dell\'utente');
        return;
      }

      onUserAdded?.(result.user);
    } catch (error) {
      setError('Errore nella creazione dell\'utente');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e?.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full max-h-[calc(100vh-2rem)] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">Aggiungi Nuovo Utente</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6">
          {/* Error Display */}
          {error && (
            <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
              {error}
            </div>
          )}

          {/* Username */}
          <div className="mb-4">
            <label htmlFor="username" className="flex items-center text-sm font-medium text-gray-700 mb-2">
              <User className="w-4 h-4 mr-2" />
              Nome Utente
            </label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData?.username}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              placeholder="Inserisci nome utente"
              required
            />
          </div>

          {/* Full Name */}
          <div className="mb-4">
            <label htmlFor="fullName" className="flex items-center text-sm font-medium text-gray-700 mb-2">
              <User className="w-4 h-4 mr-2" />
              Nome Completo
            </label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              value={formData?.fullName}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              placeholder="Inserisci nome completo"
              required
            />
          </div>

          {/* Role */}
          <div className="mb-4">
            <label htmlFor="role" className="flex items-center text-sm font-medium text-gray-700 mb-2">
              <Shield className="w-4 h-4 mr-2" />
              Ruolo
            </label>
            <select
              id="role"
              name="role"
              value={formData?.role}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="order_user">Venditore</option>
              <option value="admin">Amministratore</option>
            </select>
          </div>

          {/* Password */}
          <div className="mb-6">
            <label htmlFor="password" className="flex items-center text-sm font-medium text-gray-700 mb-2">
              <Lock className="w-4 h-4 mr-2" />
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData?.password}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              placeholder="Inserisci password"
              required
              minLength={6}
            />
            <p className="mt-1 text-xs text-gray-500">
              La password deve contenere almeno 6 caratteri
            </p>
          </div>

          {/* Actions */}
          <div className="flex flex-col-reverse gap-3 sm:flex-row sm:items-center sm:justify-end">
            <button
              type="button"
              onClick={onClose}
              className="w-full px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500 sm:w-auto"
            >
              Annulla
            </button>
            <button
              type="submit"
              disabled={loading}
              className="w-full px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed sm:w-auto"
            >
              {loading ? 'Creazione...' : 'Crea Utente'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUserModal;
